let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6qSxH")).then(() => parcelRequire('gf2wp'));